module.exports = __webpack_public_path__ + "img/Dolphin1.3a8b6a4c.png";